import { DefaultProductOptions } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

export const getUserAddManuallyRecipientTag = ({ options }: { options: DefaultProductOptions }) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );
  const event = [
    {
      eventInfo: {
        eventName: 'recipient address',
        eventAction: 'manual add address',
      },
    },
  ];

  const { modal, user } = getPODModalTag('Address the Envelope - Recipient', event, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
